import { IQuantity } from 'Data/ViewModels/Core/IQuantity';
import { ISieveSize } from 'Data/ViewModels/Equipment/ISieveSize';
import { IApiDataModel } from 'Data/ViewModels/IApiDataModel';
import { IWorksheetComponent } from '../Core';

//A common interface used for Portion Sieving Record Grids
//Used by BS EN ISO and ASTM
export interface IPortionSievingRecordGridComponent extends IWorksheetComponent {
  isCoarsePortionOfSeparationDuringSieving: boolean;
}

export const cumulativeOptions = [
  { label: 'Cumulative', value: true },
  { label: 'Individual', value: false },
];

export enum PercentageType {
  PassingCumulative = 'PassingCumulative',
  RetainedCumulative = 'RetainedCumulative',
  RetainedIndividual = 'RetainedIndividual',
}

export enum Phase {
  Never = 'Never',
  WholePortion = 'WholePortion',
  AfterFirstSeparation = 'AfterFirstSeparation',
  AfterSecondSeparation = 'AfterSecondSeparation',
  AfterThirdSeparation = 'AfterThirdSeparation',
}

export enum DryingEquipment {
  Hotplate = 'Hotplate',
  Oven = 'Oven',
  MicrowaveOven = 'MicrowaveOven',
  InfraredLight = 'InfraredLight',
}

export enum StateOfMaterial {
  Moist = 'Moist',
  AirDry = 'AirDry',
  OvenDry = 'OvenDry',
}

export enum PreparationMethod {
  Moist = 'Moist',
  AirDry = 'AirDry',
  OvenDry = 'OvenDry',
  PreTreated = 'PreTreated',
}

export enum ConditionOfSampleTested {
  PreDried = 'PreDried',
  OvenDry = 'OvenDry',
  WashedWetThenOvenDried = 'WashedWetThenOvenDried',
  AsReceived = 'AsReceived',
  AirDried = 'AirDried',
}

export enum WetMassSource {
  Undetermined = 'Undetermined',
  Measured = 'Measured',
  MeasuredInMoistureContentTest = 'MeasuredInMoistureContentTest',
  CalculatedFromSeparationChildMasses = 'CalculatedFromSeparationChildMasses',
  CalculatedFromSeparationParentAndSibling = 'CalculatedFromSeparationParentAndSibling',
}

export enum DryMassSource {
  Undetermined = 'Undetermined',
  Measured = 'Measured',
  MeasuredInMoistureContentTest = 'MeasuredInMoistureContentTest',
  MeasuredInPretreatment = 'MeasuredInPretreatment',
  CalculatedFromSeparationChildMasses = 'CalculatedFromSeparationChildMasses',
  CalculatedFromSeparationParentAndSiblingMasses = 'CalculatedFromSeparationParentAndSiblingMasses',
  CalculatedFromMoistureContentAndWetMass = 'CalculatedFromMoistureContentAndWetMass',
  DeterminedBySieving = 'DeterminedBySieving',
  CoarsePortionPanMass = 'CoarsePortionPanMass',
  ConstantDryMassDetermination = 'ConstantDryMassDetermination',
  ConstantDryMassDeterminationInPretreatment = 'ConstantDryMassDeterminationInPretreatment',
  CalculatedAsProductOfWetMassAndConstantDryMassDeterminationMassesRatio = 'CalculatedAsProductOfWetMassAndConstantDryMassDeterminationMassesRatio',
}

export enum MaterialDryMassObtainedBy {
  Measured = 'Measured',
  Imported = 'Imported',
}

export type SievingRecord = IApiDataModel & {
  Sieve?: any;
  SieveSize?: ISieveSize;
  SieveSizeId?: string;
  MassRetainedReadings?: Array<IQuantity>;
  IndividualMassRetained?: IQuantity;
  IndividualMassRetainedReadings?: Array<IQuantity>;
  CumulativeMassRetained?: IQuantity;
  MaximumIndividualMassRetained?: IQuantity;
  PercentagePassing?: number;
  PercentageRetained?: number;
  IndividualPercentageRetained?: number;
  IsRequired?: boolean;
};
